import {Popper as GWCPopper, PopperProps} from '@gwc/core'

import {useScrollLock} from '../lock-body-scroll'

export function Popper(props: Omit<PopperProps<'div'>, 'ref' | 'key'>) {
  useScrollLock(props.opened)

  return <GWCPopper {...props} />
}
